<template>
  <div class="edit-link-copy-button">
    <button
      type="button"
      title="クリップボードにコピー"
      v-clipboard:copy="copyText"
      v-clipboard:success="onCopy"
      v-clipboard:error="onError"
    >
      <i class="fas fa-clipboard"></i>
    </button>
  </div>
</template>

<script>
export default {
  props: [
    'copyText',
    'target',
  ],
  methods: {
    onCopy () {
      this.$store.commit('showMessageToast', {
        kind: 'success',
        message: `${this.target}をコピーしました`,
      })
    },
    onError () {
      this.$store.commit('showMessageToast', {
        kind: 'error',
        message: `${this.target}をコピーできませんでした`
      })
    },
  },
}
</script>

<style lang="scss" scoped>
.edit-link-copy-button {
  button {
    margin-left: 10px;
    font-size: 14px;
    text-decoration: underline;
    user-select: none;
    cursor: pointer;
  }
}
</style>
